import { useQuery } from "@tanstack/react-query";
import { chatApi } from "../../api/chat";

export const useGetConfirmedMessageIds = (roomId: string) => {
  return useQuery({
    queryKey: ["get-confirmed-message-ids", roomId],
    queryFn: () => chatApi.getConfirmedMessageIds(roomId),
    enabled: !!roomId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
};
